import React from 'react';
import { motion } from 'framer-motion';

const Button4 = ({ children, onClick, width }) => {
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className="py-2 px-6 flex items-center justify-center text-white border-4 border-white font-bold rounded-full text-center"
      style={{
        width: width || 'auto',
        borderRadius: '50px',
      }}
    >
      {children}
    </motion.button>
  );
};

export default Button4;
